<script setup>
const baseUrl = useRuntimeConfig().public.pntBaseUrl;
defineEmits(["register-event"]);
</script>
<template>
  <SkeletonLazy image-src="/images/hero-dsk.png" overlay ratio="1200 / 490">
    <div
      class="absolute right-12 lg:right-32 top-[5%] lg:top-[14.5%] tracking-wide w-1/2 lg:w-[42%] text-white flex flex-col justify-between z-30"
    >
      <h1
        class="text-lg lg:text-xl lg:mb-2 xl:text-[40px] xl:mb-5 xl:leading-[50px] font-bold text-white"
      >
        Scopri il nostro programma fedeltà Prénatal Lover
      </h1>

      <p
        class="text-white lg:mb-2 xl:mb-6 mb-2 tracking-normal text-xs xl:leading-5 xl:text-base"
      >
        Prénatal premia la tua fedeltà con una nuova raccolta punti.
        Ti aspettano tanti vantaggi, sconti e servizi dedicati.
      </p>

      <div
        class="w-full flex justify-between gap-5 items-end text-center text-sm lg:text-base"
      >
        <div class="w-56">
          <h1 class="font-bold mb-3">
            Non hai ancora <br />
            una card?
          </h1>
          <nuxt-link
            :to="`${baseUrl}/registrazione-qr/?utm_source=prenatal&utm_medium=hpareaclienti&utm_campaign=prenatal-lover`"
            target="_blank"
            @click="$emit('register-event')"
          >
            <CorePrimaryButton class="sm:text-xs lg:text-base !rounded-lg">
              <div>REGISTRATI ORA, È GRATIS</div>
            </CorePrimaryButton>
          </nuxt-link>
        </div>
        <div class="w-56">
          <h1 class="font-bold mb-3">
            Vuoi gestire il tuo profilo e i tuoi vantaggi?
          </h1>
          <nuxt-link to="/login" @click="$emit('register-event')">
            <CorePrimaryButton class="sm:text-xs lg:text-base !rounded-lg">
              <div>ACCEDI ALLA TUA AREA PERSONALE</div>
            </CorePrimaryButton>
          </nuxt-link>
        </div>
      </div>
    </div>
  </SkeletonLazy>
</template>
